import { IPay, IPayData } from "./pay.types";

export class Pay implements IPay {
    version: string;
    merchantId: string;
    paymentDescription: string;
    orderId: string;
    currency: string;
    amount: string;
    userDefined1: string;
    userDefined2: string;
    enableStoreCard: string;
    request3ds: string;
    hashValue: string;

    constructor(data: IPayData){
        this.version = data.version
        this.merchantId = data.merchantId
        this.paymentDescription = data.paymentDescription
        this.orderId = data.orderId
        this.currency = data.currency
        this.amount = data.amount
        this.userDefined1 = data.userDefined1
        this.userDefined2 = data.userDefined2
        this.enableStoreCard = data.enableStoreCard
        this.request3ds = data.request3ds
        this.hashValue = data.hashValue
    }
    data(): IPayData {
        return Object.assign({}, this)
    }
}